export const COLLABORATION_METHOD_OPTION_KEY = 'CollaborationMethodOption';
export const COLLABORATION_METHOD_SYNC = 'Sync';
export const COLLABORATION_METHOD_ASYNC = 'Async';
export const DESIGN_LIVE_REVIEW_METHOD = 'DesignLive';

export interface ProductOptionWithKey {
    key: { key: string };
}

/**
 * Checks whether CollaborationMethodOption is present.
 *
 * Accepts either:
 * - A product options array (`[{ key: { key: string } }]`) from a ProductOptionsQuery
 * - A selected options record (`Record<string, string>`) built from preselected values
 */
export function hasCollaborationMethodOption(
    options: ReadonlyArray<ProductOptionWithKey | null> | Record<string, string> | null | undefined
): boolean {
    if (!options) {
        return false;
    }

    if (Array.isArray(options)) {
        return options.some((option) => option?.key.key === COLLABORATION_METHOD_OPTION_KEY);
    }

    return COLLABORATION_METHOD_OPTION_KEY in options;
}
